<template>
  <div class="send-goods">
    <div class="ceiling">
      <home-top></home-top>
      <navicat :current="-1" background="#FFFFFF"></navicat>
    </div>
    <div class="content w-1400">
      <div class="bread-crumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/user/supplier/sale-order' }"
          >销售订单
          </el-breadcrumb-item
          >
          <el-breadcrumb-item>发货</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="body-content">
        <div class="body-title">订单信息</div>
        <div class="address-box">
          <div class="address-title">收货地址</div>
          <div class="assress-content" v-if="is_vip">
            <div class="user-name" v-if="detail.address">
              <span class="name">{{ detail.address.name }}</span>
              <span class="phone">{{ detail.address.phone }}</span>
            </div>
            <div class="address-detail" v-if="detail.address">
              <span>{{ detail.address.province }}</span>
              <span>{{ detail.address.city }}</span>
              <span>{{ detail.address.district }}</span>
              <span>{{ detail.address.address }}</span>
            </div>
          </div>

          <div class="vip-upgrade-prompt" v-else>
            <div class="contact-service">
              <span class="service-text">您可以
                <el-tag @click="govip" class="hit-cursor" size="mini" type="warning" effect="dark">升级为VIP</el-tag>用户查看</span>
            </div>
            <div class="contact-service">
              <span class="divider">|</span>
              <span class="service-text">联系客服获取</span>
              <a href="tel:400-xxx-xxxx" class="service-link">{{ kefu }}</a>
            </div>
          </div>
        </div>
        <div class="order-info">
          <div class="order-info-title">订单信息</div>
          <el-table
              :data="orderList"
              style="width: 100%"
              border
              :header-cell-style="{
              background: '#F5F5F5',
              color: '#00112B',
              fontWeight: 'bold',
              textAlign: 'center',
            }"
              :cell-style="{ textAlign: 'center' }"
          >
            <el-table-column prop="orderno" label="订单编号"/>
            <el-table-column prop="product_name" label="商品名称"/>
            <el-table-column prop="cas_no" label="CAS号"/>
            <el-table-column prop="quantity" label="规格"/>
            <el-table-column prop="unit_price" label="单价"/>
            <el-table-column prop="number" label="数量"/>
            <el-table-column prop="total_price" label="小计">
              <template slot-scope="scope">
                <span class="total-price">{{ (scope.row.total_price - scope.row.service).toFixed(2) }}元</span>
              </template>
            </el-table-column>
            <el-table-column prop="total" label="物流公司">
              <template slot-scope="scope">
<!--                <el-input-->
<!--                    v-model="scope.row.express_company"-->
<!--                    type="select"-->
<!--                    @click="show = true"-->
<!--                    placeholder="物流公司"-->
<!--                />-->
                <el-autocomplete
                    class="inline-input"
                    v-model="scope.row.express_company"
                    :fetch-suggestions="querySearch"
                    placeholder="物流公司"
                ></el-autocomplete>
              </template>
            </el-table-column>
            <el-table-column prop="total" label="物流单号">
              <template slot-scope="scope">
                <el-input
                    v-model="scope.row.express_order"
                    placeholder="物流单号"
                />
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="submit">
          <gradient-button background="#387DF6" @hit="submit"
          >确认发货
          </gradient-button
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import homeTop from "@/components/public/home-top.vue";
import navicat from "@/components/navicat/navicat.vue";
import {purchase_order_detail, delivery} from "@/api/modules/user.js";
import {getExpressList} from "@/api/modules/common.js";
import {getMyCustomerService} from "@/api/modules/user";
import GradientButton from "@/components/button/gradient-button.vue";
import {unifiedPayment} from "../../../api";
import {mapGetters} from "vuex";
export default {
  name: "sendGoods",
  components: {
    homeTop,
    navicat,
    GradientButton,
  },
  data() {
    return {
      order_id: this.$route.query.order_id,
      detail: {},
      orderList: [],
      exprName: '',
      expressList: [],
      show: false,
      kefu: ''
    };
  },
  computed: {
    ...mapGetters(["is_vip"]),
  },
  created() {
    this.getOrderInfo();
    this.getKefu()
  },
  methods: {
    govip() {
      this.$router.push({
        path: "/vip",
      });
    },
    getKefu() {
      getMyCustomerService().then(res => {
        this.kefu = res.data.data.mobile
      })
    },
    querySearch(queryString, cb) {
      this.exprName = queryString;
      getExpressList({name: this.exprName}).then(res => {
        let results = [];
        if (res.data && typeof res.data === 'object') {
          if (Array.isArray(res.data)) {
            // 如果是数组
            results = res.data.map(item => {
              return {
                value: item.name
              }
            });
          } else {
            // 如果是对象，转换为数组
            results = [{
              value: res.data.name || '' // 根据实际对象结构调整
            }];
          }
        }

        // 调用 callback 返回建议列表的数据
        cb(results);
      }).catch(error => {
        cb([]); // 发生错误时返回空数组
      });
    },

    // 提交
    submit() {
      let data = {
        express_order: this.orderList[0].express_order,
        express_company: this.orderList[0].express_company,
      };
      if (!data.express_company) {
        this.$message.error({
          message: "请输入物流公司",
          duration: 2000,
          offset: 200,
        });
        return;
      }
      if (!data.express_order) {
        this.$message.error({
          message: "请输入物流单号",
          duration: 2000,
          offset: 200,
        });
        return;
      }

      delivery(this.order_id, data).then((res) => {
        if (res.data.code == 10000) {
          this.$message.success({
            message: res.data.message,
            duration: 2000,
            offset: 200,
          });
          this.$router.push({
            path: "/user/supplier/sale-order",
          });
        } else {
          this.$message.error({
            message: res.data.message,
            duration: 2000,
            offset: 200,
          });
        }
      });
    },
    getOrderInfo() {
      purchase_order_detail(this.order_id).then((res) => {
        this.detail = res.data.data;
        let data = res.data.data;
        this.orderList = [
          {
            orderno: data.orderno,
            product_name: data.product_name,
            cas_no: data.cas_no,
            quantity: data.unit,
            unit_price: data.unit_price,
            number: data.cart_num,
            total_price: data.total_price,
            express_company: "",
            express_order: "",
            service: data.service,
          },
        ];
      });
    },
  },
};
</script>
<style scoped lang="scss">
.total-price {
  font-weight: bold;
  font-size: 18px;
  color: #ff4400;
}

.content {
  // margin-top: 142px;
  // margin-top: 120px;

  .bread-crumb {
    padding: 20px 0;
  }

  .body-content {
    background-color: #fff;
    padding: 30px;

    .body-title {
      font-weight: 800;
      font-size: 20px;
      color: #00112b;
    }

    .address-box {
      box-sizing: border-box;

      .address-title {
        padding: 40px 0 30px;
        font-weight: bold;
        font-size: 18px;
        color: #00112b;
      }

      .vip-upgrade-prompt {
        display: flex;
        align-items: center;
        padding: 20px 30px;
        background: linear-gradient(90deg, #f8f9ff 0%, #eff2ff 100%);
        border-radius: 8px;
        border: 1px solid #e0e4ff;

        .prompt-text {
          display: flex;
          align-items: center;

          .tip-icon {
            font-size: 20px;
            margin-right: 12px;
            color: #ff6b35;
          }

          .text {
            font-size: 16px;
            font-weight: 500;
            color: #333;
          }
        }

        .contact-service {
          display: flex;
          align-items: center;

          .divider {
            color: #ccc;
            margin: 0 15px;
          }

          .service-text {
            font-size: 14px;
            color: #666;
            margin-right: 8px;
          }

          .service-link {
            font-size: 16px;
            font-weight: 600;
            color: #387DF6;
            text-decoration: none;

            &:hover {
              text-decoration: underline;
            }
          }
        }
      }

      .assress-content {
        background: #f5f5f5;
        border: 1px solid #d8d8d8;
        padding: 19px 40px;
        border-radius: 5px;


        .user-name {
          font-weight: bold;
          font-size: 18px;
          color: #333333;
          margin-bottom: 10px;

          .name {
            display: inline-block;
            margin-right: 20px;
          }
        }

        .address-detail {
          font-weight: 400;
          font-size: 18px;
          color: #5f616c;
        }
      }
    }

    .order-info {
      .order-info-title {
        padding: 40px 0 30px;
        font-weight: bold;
        font-size: 18px;
      }
    }

    .submit {
      display: flex;
      justify-content: flex-end;
      margin-top: 30px;
    }
  }
}
</style>
